(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blank-metal-catalog"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-blank-catalog]').forEach((catalog)=>{const rows=[...catalog.querySelectorAll('[data-catalog-row]')];const family=catalog.querySelector('[data-filter="family"]');const size=catalog.querySelector('[data-filter="size"]');const material=catalog.querySelector('[data-global-option="Material"]');const count=catalog.querySelector('[data-result-count]');const money=new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'});function matchVariant(row){const variants=JSON.parse(row.querySelector('[data-variants]').textContent);const selected=[...row.querySelectorAll('[data-option-position]')].map((select)=>select.value);const variant=variants.find((item)=>item.options.every((value,index)=>value===selected[index]));const button=row.querySelector('button[type="submit"]');if(!variant){row.querySelector('[data-sku]').textContent='Configuration unavailable';row.querySelector('[data-price]').textContent='';row.querySelector('[data-unit-price]').textContent='';row.querySelector('[data-status]').textContent='Choose another combination';button.disabled=true;return}row.querySelector('[data-variant-id]').value=variant.id;row.querySelector('[data-sku]').textContent=variant.sku;row.querySelector('[data-price]').textContent=money.format(variant.price/100)+' / pack';const pack=Number(selected[selected.length-1]);row.querySelector('[data-unit-price]').textContent=pack?money.format(variant.price/100/pack)+' each':'';row.querySelector('[data-status]').textContent=variant.available?'':'Currently unavailable';button.disabled=!variant.available}function filter(){let shown=0;rows.forEach((row)=>{const visible=(!family.value||row.dataset.family===family.value)&&(!size.value||row.dataset.title.includes(size.value.toLowerCase().replaceAll('x','×')));row.hidden=!visible;if(visible)shown+=1});count.textContent=shown}rows.forEach((row)=>{row.querySelectorAll('[data-option-position]').forEach((select)=>select.addEventListener('change',()=>matchVariant(row)));matchVariant(row)});family.addEventListener('change',filter);size.addEventListener('input',filter);material.addEventListener('change',()=>{rows.forEach((row)=>{const select=[...row.querySelectorAll('[data-option-name]')].find((item)=>item.dataset.optionName==='Material');if(select&&material.value&&[...select.options].some((option)=>option.value===material.value)){select.value=material.value;matchVariant(row)}})});catalog.querySelector('[data-reset]').addEventListener('click',()=>{family.value='';size.value='';material.value='';filter()});filter()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
